// src/components/Header.js
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // useNavigateをインポート
import Modal from 'react-modal'; // モーダルをインポート
import './Header.css'; // Header用のCSSファイル
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

const Header = ({ WuserName, onLogout, onToggleSidebar,userType }) => {  // ← 引数に onToggleSidebar を追加

  const isGeneral = userType === '一般';
  const [dropdownOpen, setDropdownOpen] = useState(false); // ドロップダウンの状態を管理
  const [modalIsOpenHeader01, setModalIsOpenHeader01] = useState(false); // モーダル状態
  const dropdownRef = useRef(null); 

  const [searchResults, setSearchResults] = useState({}); // 検索結果データの状態
  const navigate = useNavigate(); // navigate関数を取得
  

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // ↓ 追加：外側クリック＆Escで閉じる
  useEffect(() => {
    if (!dropdownOpen) return;

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') setDropdownOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [dropdownOpen]);
  

  const handleSettings = () => {
    setDropdownOpen(false);
    navigate('/usersettings'); // Header-01.jsのルートに遷移
  };

  const closeModalHeader01 = () => {
    setModalIsOpenHeader01(false); // モーダルを閉じる
  };

  const handleLogout = () => {
    setDropdownOpen(false);
  
    sessionStorage.clear();

    onLogout(); // ログアウト処理を呼び出し
  };


  // ロゴをクリックしたときの処理
 const handleLogoClick = () => {
   if (userType === 'admin') navigate('/admin/dashboard');
   else if (userType === 'operator') navigate('/operator/dashboard');
   else navigate('/enduser/dashboard');
 };



  const SettingsClick = async () => {
    try {
        const response = await axios.post(
            `${API_URL}/api/ItemHeader_01/`);

        console.log("サーバーからのレスポンス:", response.data); // デバッグ用

        if (response.data.success) {
            // レスポンスの `data` フィールドを直接設定
            setSearchResults(response.data.data || {});
        } else {
            console.error("サーバーエラー:", response.data.message);
        }
    } catch (error) {
        console.error("リクエストエラー:", error.response?.data || error.message);
    }
};
     

  return (
   <div className="header">
        {/* 一般ユーザーのときはハンバーガーを出さない */}
      {!isGeneral && (
        <button className="hamburger" onClick={onToggleSidebar} aria-label="メニュー">
          ☰
        </button>
      )}
      <h1 className="logo-text" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <img src="/event_plus_logo.png" alt="予定PLUS ロゴ" className="logo-image" />
      </h1>
      
      <div className="user-info">
        {WuserName ? (
            <div className="user-dropdown" ref={dropdownRef}>
            <p onClick={toggleDropdown} aria-haspopup="menu" aria-expanded={dropdownOpen}>
              {WuserName} ▼
            </p>
            {dropdownOpen && (
               <div className="dropdown-menu" role="menu">
               <div> <button onClick={handleSettings}>個人設定</button> </div>
               <div> <button onClick={handleLogout}>ログアウト</button> </div>
              </div>
            )}
          </div>
        ) : (
          <p>ゲスト</p>
        )}
      </div>


      {/* モーダル部分 */}
      <Modal
        isOpen={modalIsOpenHeader01}
        ariaHideApp={false}
        onRequestClose={closeModalHeader01}
        contentLabel="編集モーダル"
        className="modalHeader01"
        overlayClassName="overlayHeader01"
        shouldCloseOnOverlayClick={false}
      >
        <div className="modal-headerHeader01">
          <label>個人設定</label>
          <button onClick={closeModalHeader01} className="close-modalHeader01">✕</button>
        </div>
        <div className="modal-bodyHeader01">
          {/* 必要に応じて内容を挿入 */}
          <p>個人設定の内容をここに表示します。</p>

        {/* 取得したデータをリスト表示 */}
        <div>
            {searchResults && searchResults.name ? (
                <ul>
                    <li>
                        <p>名前: {searchResults.name}</p>
                        <p>ID: {searchResults.id}</p>
                        <p>ステータス: {searchResults.pass}</p>
                    </li>
                </ul>
            ) : (
                <p>データがありません</p>
            )}
        </div>

        </div>
        <div className="modal-footerHeader01">
          <button onClick={closeModalHeader01} className="btn-saveHeader01">保存</button>
        </div>
      </Modal>

    </div>
  );
};

export default Header;
